import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
class ModelList extends WizContainer {

  componentName = 'ModelList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig({doAction:this.doAction,_getActionKey:this._getActionKey,dispatch:this.dispatch,_pushAction:this._pushAction,containerActions:this.containerActions,_checkActionNeedInit:this._checkActionNeedInit,props:this.props}),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        deploy: this._handleCMD
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ModelList);
